import { jsx as _jsx } from "react/jsx-runtime";
import ListInfos from "./ListInfos";
const ListInfosPreview = () => {
    return (_jsx(ListInfos, { dynamicList: [
            {
                label: "Protection supervisée des postes",
                description: "Suivi en temps réel des alertes de sécurité.",
            },
            {
                label: "Sauvegarde sécurisée",
                description: "Historique et état de vos sauvegardes critiques.",
            },
        ] }));
};
export default ListInfosPreview;
